import { useTranslation } from 'react-i18next';

import { FeatureErrorBoundary } from '@nucleus-commerce/admin-kit/errors';
import { PageContent, PageHeader } from '@nucleus-commerce/admin-kit/layout';

import { session } from '@/shared/session/session';

import { DefaultWeightUnitCard } from '../components/default-weight-unit-card';
import { OrganizationProfileCard } from '../components/organization-profile-card';
import { RequireTwoFactorCard } from '../components/require-two-factor-card';

/** Settings that apply to every store and staff member of the organisation. */
export function OrganizationSettingsPage() {
  const { t } = useTranslation('organization');
  const { me } = session.useSession();
  return (
    <PageContent>
      <PageHeader
        title={t('title')}
        description={t('description', { organization: me?.organization.name ?? '' })}
      />
      <div className="flex flex-col gap-6">
        <FeatureErrorBoundary name="organization.profile">
          <OrganizationProfileCard />
        </FeatureErrorBoundary>
        <FeatureErrorBoundary name="organization.settings">
          <RequireTwoFactorCard />
        </FeatureErrorBoundary>
        <FeatureErrorBoundary name="organization.catalog">
          <DefaultWeightUnitCard />
        </FeatureErrorBoundary>
      </div>
    </PageContent>
  );
}
